import i18n from 'helpers/i18n';
import messages from './messages';
import { RecommendationMetadata } from 'types/api/ClassScoresRecommendation';

interface RecommendationBannerProps {
  metadata: RecommendationMetadata | null;
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  });
}

export default function RecommendationBanner({
  metadata
}: RecommendationBannerProps) {
  if (!metadata) {
    return (
      <div className="bg-white border border-charcoal-100 rounded-lg p-4 mt-4">
        <div className="flex items-center gap-2 mb-2">
          <i className="fa-regular fa-circle-info text-blue-500" />
          <h4 className="font-semibold text-text-dark text-sm">
            {i18n.ft(messages.title)}
          </h4>
        </div>
        <p className="text-charcoal-400 text-sm">
          {i18n.ft(messages.emptyDescription)}
        </p>
        <button
          type="button"
          className="text-action text-sm mt-3 inline-flex items-center gap-1 underline bg-transparent border-0 p-0 cursor-pointer"
        >
          {i18n.ft(messages.howDetermined)}
          <i className="fa-solid fa-arrow-up-right text-xs" />
        </button>
      </div>
    );
  }

  const dim = metadata.dimensions[0];

  return (
    <div className="bg-white border border-charcoal-100 rounded-lg p-4 mt-4">
      <div className="flex items-center gap-2 mb-2">
        <i className="fa-regular fa-circle-info text-blue-500" />
        <h4 className="font-semibold text-text-dark text-sm">
          {i18n.ft(messages.title)}
        </h4>
      </div>
      <p className="text-charcoal-400 text-sm">
        {i18n.ft(messages.descriptionBefore)}{' '}
        <strong className="text-text-dark">{dim?.name}</strong>
        {i18n.ft(messages.descriptionAfter, {
          date: formatDate(metadata.taken_at)
        })}
      </p>
      <button
        type="button"
        className="text-action text-sm mt-3 inline-flex items-center gap-1 underline bg-transparent border-0 p-0 cursor-pointer"
      >
        {i18n.ft(messages.howDetermined)}
        <i className="fa-solid fa-arrow-up-right text-xs" />
      </button>
    </div>
  );
}
